// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu-module--sideMenu--3u-Y5","sideLinks":"SideMenu-module--sideLinks--2JMTK","sideLinks2":"SideMenu-module--sideLinks2--3ckDl"};